<template>
    <div class="forex-index">
        <page-navigate></page-navigate>

        <div class="forex-wrapper cn">
            <forexMenu />
            <div class="forex-wrapper-body">
                <div class="en-box">
                    <div data-lang="cn" class="main-wrap">
                        <div class="main-content">
                            <main class="wrapper">
                                <div class="calculator">
                                    <div class="breadcrumb-box">
                                        <div class="breadcrumb-link-item">
                                            <a href="/jinrong/" class="breadcrumb-link">交易学院</a>
                                        </div>

                                        <div class="breadcrumb-link-item">
                                            <a href="/forex-tools/" class="breadcrumb-link">交易计算器</a>
                                        </div>
                                        <div class="breadcrumb-link-item">
                                            <span class="breadcrumb-link">点值计算器</span>
                                        </div>
                                    </div>
                                    <section class="section1">
                                        <div class="calculator__wrap">
                                            <h1>点值计算器</h1>
                                            <div class="forex-title-intro">
                                                <p>
                                                    如果您想知道任何外汇交易货币的单个点的价格，请使用此点值计算器。在处理许多或异国货币对时，使用这个免费的外汇工具来计算和计划您的订单。您需要做的就是填写下面的表格，然后按“计算”按钮：
                                                </p>
                                            </div>
                                            <form data-formula="CalcPip" name="f" id="f"
                                                class="calculator__form form form-calculator">
                                                <div>
                                                    <span class="input__label"><strong>账户货币</strong></span>
                                                    <div class="custom-dropdown select-currency">
                                                        <div class="field cs-placeholder">EUR</div>
                                                        <ul class="cs-options">
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-USD" name="currency"
                                                                    class="hidden-cbx" value="USD" />
                                                                <label for="rbx-c-USD" class="rbx-option">USD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-EUR" name="currency"
                                                                    class="hidden-cbx" value="EUR" checked="checked" />
                                                                <label for="rbx-c-EUR" class="rbx-option">EUR</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-GBP" name="currency"
                                                                    class="hidden-cbx" value="GBP" />
                                                                <label for="rbx-c-GBP" class="rbx-option">GBP</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-JPY" name="currency"
                                                                    class="hidden-cbx" value="JPY" />
                                                                <label for="rbx-c-JPY" class="rbx-option">JPY</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-CHF" name="currency"
                                                                    class="hidden-cbx" value="CHF" />
                                                                <label for="rbx-c-CHF" class="rbx-option">CHF</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-CAD" name="currency"
                                                                    class="hidden-cbx" value="CAD" />
                                                                <label for="rbx-c-CAD" class="rbx-option">CAD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-AUD" name="currency"
                                                                    class="hidden-cbx" value="AUD" />
                                                                <label for="rbx-c-AUD" class="rbx-option">AUD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-NZD" name="currency"
                                                                    class="hidden-cbx" value="NZD" />
                                                                <label for="rbx-c-NZD" class="rbx-option">NZD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-SGD" name="currency"
                                                                    class="hidden-cbx" value="SGD" />
                                                                <label for="rbx-c-SGD" class="rbx-option">SGD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-DKK" name="currency"
                                                                    class="hidden-cbx" value="DKK" />
                                                                <label for="rbx-c-DKK" class="rbx-option">DKK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-PLN" name="currency"
                                                                    class="hidden-cbx" value="PLN" />
                                                                <label for="rbx-c-PLN" class="rbx-option">PLN</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-CCK" name="currency"
                                                                    class="hidden-cbx" value="CCK" />
                                                                <label for="rbx-c-CCK" class="rbx-option">CCK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-HKD" name="currency"
                                                                    class="hidden-cbx" value="HKD" />
                                                                <label for="rbx-c-HKD" class="rbx-option">HKD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-HUF" name="currency"
                                                                    class="hidden-cbx" value="HUF" />
                                                                <label for="rbx-c-HUF" class="rbx-option">HUF</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-LVL" name="currency"
                                                                    class="hidden-cbx" value="LVL" />
                                                                <label for="rbx-c-LVL" class="rbx-option">LVL</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-NOK" name="currency"
                                                                    class="hidden-cbx" value="NOK" />
                                                                <label for="rbx-c-NOK" class="rbx-option">NOK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-ZAR" name="currency"
                                                                    class="hidden-cbx" value="ZAR" />
                                                                <label for="rbx-c-ZAR" class="rbx-option">ZAR</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-SEK" name="currency"
                                                                    class="hidden-cbx" value="SEK" />
                                                                <label for="rbx-c-SEK" class="rbx-option">SEK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-HRK" name="currency"
                                                                    class="hidden-cbx" value="HRK" />
                                                                <label for="rbx-c-HRK" class="rbx-option">HRK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-LTL" name="currency"
                                                                    class="hidden-cbx" value="LTL" />
                                                                <label for="rbx-c-LTL" class="rbx-option">LTL</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-MXN" name="currency"
                                                                    class="hidden-cbx" value="MXN" />
                                                                <label for="rbx-c-MXN" class="rbx-option">MXN</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-RUB" name="currency"
                                                                    class="hidden-cbx" value="RUB" />
                                                                <label for="rbx-c-RUB" class="rbx-option">RUB</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-c-CNH" name="currency"
                                                                    class="hidden-cbx" value="CNH" />
                                                                <label for="rbx-c-CNH" class="rbx-option">CNH</label>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div>
                                                    <span class="input__label"><strong>货币对</strong></span>
                                                    <div class="custom-dropdown select-pair">
                                                        <div class="field cs-placeholder">EUR/USD</div>
                                                        <ul class="cs-options">
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/USD" name="pair"
                                                                    class="hidden-cbx" value="EUR/USD"
                                                                    checked="checked" />
                                                                <label for="rbx-p-EUR/USD"
                                                                    class="rbx-option">EUR/USD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/USD" name="pair"
                                                                    class="hidden-cbx" value="GBP/USD" />
                                                                <label for="rbx-p-GBP/USD"
                                                                    class="rbx-option">GBP/USD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/JPY" name="pair"
                                                                    class="hidden-cbx" value="USD/JPY" />
                                                                <label for="rbx-p-USD/JPY"
                                                                    class="rbx-option">USD/JPY</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/CHF" name="pair"
                                                                    class="hidden-cbx" value="USD/CHF" />
                                                                <label for="rbx-p-USD/CHF"
                                                                    class="rbx-option">USD/CHF</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/CAD" name="pair"
                                                                    class="hidden-cbx" value="USD/CAD" />
                                                                <label for="rbx-p-USD/CAD"
                                                                    class="rbx-option">USD/CAD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/JPY" name="pair"
                                                                    class="hidden-cbx" value="EUR/JPY" />
                                                                <label for="rbx-p-EUR/JPY"
                                                                    class="rbx-option">EUR/JPY</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/JPY" name="pair"
                                                                    class="hidden-cbx" value="GBP/JPY" />
                                                                <label for="rbx-p-GBP/JPY"
                                                                    class="rbx-option">GBP/JPY</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-AUD/USD" name="pair"
                                                                    class="hidden-cbx" value="AUD/USD" />
                                                                <label for="rbx-p-AUD/USD"
                                                                    class="rbx-option">AUD/USD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-NZD/USD" name="pair"
                                                                    class="hidden-cbx" value="NZD/USD" />
                                                                <label for="rbx-p-NZD/USD"
                                                                    class="rbx-option">NZD/USD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/GBP" name="pair"
                                                                    class="hidden-cbx" value="EUR/GBP" />
                                                                <label for="rbx-p-EUR/GBP"
                                                                    class="rbx-option">EUR/GBP</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/CHF" name="pair"
                                                                    class="hidden-cbx" value="EUR/CHF" />
                                                                <label for="rbx-p-EUR/CHF"
                                                                    class="rbx-option">EUR/CHF</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/AUD" name="pair"
                                                                    class="hidden-cbx" value="EUR/AUD" />
                                                                <label for="rbx-p-EUR/AUD"
                                                                    class="rbx-option">EUR/AUD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/CAD" name="pair"
                                                                    class="hidden-cbx" value="EUR/CAD" />
                                                                <label for="rbx-p-EUR/CAD"
                                                                    class="rbx-option">EUR/CAD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/NZD" name="pair"
                                                                    class="hidden-cbx" value="EUR/NZD" />
                                                                <label for="rbx-p-EUR/NZD"
                                                                    class="rbx-option">EUR/NZD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/CHF" name="pair"
                                                                    class="hidden-cbx" value="GBP/CHF" />
                                                                <label for="rbx-p-GBP/CHF"
                                                                    class="rbx-option">GBP/CHF</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/AUD" name="pair"
                                                                    class="hidden-cbx" value="GBP/AUD" />
                                                                <label for="rbx-p-GBP/AUD"
                                                                    class="rbx-option">GBP/AUD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/CAD" name="pair"
                                                                    class="hidden-cbx" value="GBP/CAD" />
                                                                <label for="rbx-p-GBP/CAD"
                                                                    class="rbx-option">GBP/CAD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/NZD" name="pair"
                                                                    class="hidden-cbx" value="GBP/NZD" />
                                                                <label for="rbx-p-GBP/NZD"
                                                                    class="rbx-option">GBP/NZD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-AUD/CHF" name="pair"
                                                                    class="hidden-cbx" value="AUD/CHF" />
                                                                <label for="rbx-p-AUD/CHF"
                                                                    class="rbx-option">AUD/CHF</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-CAD/CHF" name="pair"
                                                                    class="hidden-cbx" value="CAD/CHF" />
                                                                <label for="rbx-p-CAD/CHF"
                                                                    class="rbx-option">CAD/CHF</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-CHF/JPY" name="pair"
                                                                    class="hidden-cbx" value="CHF/JPY" />
                                                                <label for="rbx-p-CHF/JPY"
                                                                    class="rbx-option">CHF/JPY</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-AUD/CAD" name="pair"
                                                                    class="hidden-cbx" value="AUD/CAD" />
                                                                <label for="rbx-p-AUD/CAD"
                                                                    class="rbx-option">AUD/CAD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-AUD/JPY" name="pair"
                                                                    class="hidden-cbx" value="AUD/JPY" />
                                                                <label for="rbx-p-AUD/JPY"
                                                                    class="rbx-option">AUD/JPY</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-AUD/NZD" name="pair"
                                                                    class="hidden-cbx" value="AUD/NZD" />
                                                                <label for="rbx-p-AUD/NZD"
                                                                    class="rbx-option">AUD/NZD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-CAD/JPY" name="pair"
                                                                    class="hidden-cbx" value="CAD/JPY" />
                                                                <label for="rbx-p-CAD/JPY"
                                                                    class="rbx-option">CAD/JPY</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-NZD/CAD" name="pair"
                                                                    class="hidden-cbx" value="NZD/CAD" />
                                                                <label for="rbx-p-NZD/CAD"
                                                                    class="rbx-option">NZD/CAD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-NZD/JPY" name="pair"
                                                                    class="hidden-cbx" value="NZD/JPY" />
                                                                <label for="rbx-p-NZD/JPY"
                                                                    class="rbx-option">NZD/JPY</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-AUD/DKK" name="pair"
                                                                    class="hidden-cbx" value="AUD/DKK" />
                                                                <label for="rbx-p-AUD/DKK"
                                                                    class="rbx-option">AUD/DKK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-AUD/PLN" name="pair"
                                                                    class="hidden-cbx" value="AUD/PLN" />
                                                                <label for="rbx-p-AUD/PLN"
                                                                    class="rbx-option">AUD/PLN</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-AUD/SGD" name="pair"
                                                                    class="hidden-cbx" value="AUD/SGD" />
                                                                <label for="rbx-p-AUD/SGD"
                                                                    class="rbx-option">AUD/SGD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-CHF/SGD" name="pair"
                                                                    class="hidden-cbx" value="CHF/SGD" />
                                                                <label for="rbx-p-CHF/SGD"
                                                                    class="rbx-option">CHF/SGD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/CCK" name="pair"
                                                                    class="hidden-cbx" value="EUR/CCK" />
                                                                <label for="rbx-p-EUR/CCK"
                                                                    class="rbx-option">EUR/CCK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/DDK" name="pair"
                                                                    class="hidden-cbx" value="EUR/DDK" />
                                                                <label for="rbx-p-EUR/DDK"
                                                                    class="rbx-option">EUR/DDK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/HKD" name="pair"
                                                                    class="hidden-cbx" value="EUR/HKD" />
                                                                <label for="rbx-p-EUR/HKD"
                                                                    class="rbx-option">EUR/HKD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/HUF" name="pair"
                                                                    class="hidden-cbx" value="EUR/HUF" />
                                                                <label for="rbx-p-EUR/HUF"
                                                                    class="rbx-option">EUR/HUF</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/LVL" name="pair"
                                                                    class="hidden-cbx" value="EUR/LVL" />
                                                                <label for="rbx-p-EUR/LVL"
                                                                    class="rbx-option">EUR/LVL</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/NOK" name="pair"
                                                                    class="hidden-cbx" value="EUR/NOK" />
                                                                <label for="rbx-p-EUR/NOK"
                                                                    class="rbx-option">EUR/NOK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/PLN" name="pair"
                                                                    class="hidden-cbx" value="EUR/PLN" />
                                                                <label for="rbx-p-EUR/PLN"
                                                                    class="rbx-option">EUR/PLN</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/SEK" name="pair"
                                                                    class="hidden-cbx" value="EUR/SEK" />
                                                                <label for="rbx-p-EUR/SEK"
                                                                    class="rbx-option">EUR/SEK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/SGD" name="pair"
                                                                    class="hidden-cbx" value="EUR/SGD" />
                                                                <label for="rbx-p-EUR/SGD"
                                                                    class="rbx-option">EUR/SGD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-EUR/ZAR" name="pair"
                                                                    class="hidden-cbx" value="EUR/ZAR" />
                                                                <label for="rbx-p-EUR/ZAR"
                                                                    class="rbx-option">EUR/ZAR</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/DKK" name="pair"
                                                                    class="hidden-cbx" value="GBP/DKK" />
                                                                <label for="rbx-p-GBP/DKK"
                                                                    class="rbx-option">GBP/DKK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/NOK" name="pair"
                                                                    class="hidden-cbx" value="GBP/NOK" />
                                                                <label for="rbx-p-GBP/NOK"
                                                                    class="rbx-option">GBP/NOK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/SEK" name="pair"
                                                                    class="hidden-cbx" value="GBP/SEK" />
                                                                <label for="rbx-p-GBP/SEK"
                                                                    class="rbx-option">GBP/SEK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/SGD" name="pair"
                                                                    class="hidden-cbx" value="GBP/SGD" />
                                                                <label for="rbx-p-GBP/SGD"
                                                                    class="rbx-option">GBP/SGD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-GBP/ZAR" name="pair"
                                                                    class="hidden-cbx" value="GBP/ZAR" />
                                                                <label for="rbx-p-GBP/ZAR"
                                                                    class="rbx-option">GBP/ZAR</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-NZD/SGD" name="pair"
                                                                    class="hidden-cbx" value="NZD/SGD" />
                                                                <label for="rbx-p-NZD/SGD"
                                                                    class="rbx-option">NZD/SGD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-SGD/JPY" name="pair"
                                                                    class="hidden-cbx" value="SGD/JPY" />
                                                                <label for="rbx-p-SGD/JPY"
                                                                    class="rbx-option">SGD/JPY</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/CCK" name="pair"
                                                                    class="hidden-cbx" value="USD/CCK" />
                                                                <label for="rbx-p-USD/CCK"
                                                                    class="rbx-option">USD/CCK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/CNH" name="pair"
                                                                    class="hidden-cbx" value="USD/CNH" />
                                                                <label for="rbx-p-USD/CNH"
                                                                    class="rbx-option">USD/CNH</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/DKK" name="pair"
                                                                    class="hidden-cbx" value="USD/DKK" />
                                                                <label for="rbx-p-USD/DKK"
                                                                    class="rbx-option">USD/DKK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/HKD" name="pair"
                                                                    class="hidden-cbx" value="USD/HKD" />
                                                                <label for="rbx-p-USD/HKD"
                                                                    class="rbx-option">USD/HKD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/HRK" name="pair"
                                                                    class="hidden-cbx" value="USD/HRK" />
                                                                <label for="rbx-p-USD/HRK"
                                                                    class="rbx-option">USD/HRK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/HUF" name="pair"
                                                                    class="hidden-cbx" value="USD/HUF" />
                                                                <label for="rbx-p-USD/HUF"
                                                                    class="rbx-option">USD/HUF</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/LTL" name="pair"
                                                                    class="hidden-cbx" value="USD/LTL" />
                                                                <label for="rbx-p-USD/LTL"
                                                                    class="rbx-option">USD/LTL</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/LVL" name="pair"
                                                                    class="hidden-cbx" value="USD/LVL" />
                                                                <label for="rbx-p-USD/LVL"
                                                                    class="rbx-option">USD/LVL</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/MXN" name="pair"
                                                                    class="hidden-cbx" value="USD/MXN" />
                                                                <label for="rbx-p-USD/MXN"
                                                                    class="rbx-option">USD/MXN</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/NOK" name="pair"
                                                                    class="hidden-cbx" value="USD/NOK" />
                                                                <label for="rbx-p-USD/NOK"
                                                                    class="rbx-option">USD/NOK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/PLN" name="pair"
                                                                    class="hidden-cbx" value="USD/PLN" />
                                                                <label for="rbx-p-USD/PLN"
                                                                    class="rbx-option">USD/PLN</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/RUB" name="pair"
                                                                    class="hidden-cbx" value="USD/RUB" />
                                                                <label for="rbx-p-USD/RUB"
                                                                    class="rbx-option">USD/RUB</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/SEK" name="pair"
                                                                    class="hidden-cbx" value="USD/SEK" />
                                                                <label for="rbx-p-USD/SEK"
                                                                    class="rbx-option">USD/SEK</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/SGD" name="pair"
                                                                    class="hidden-cbx" value="USD/SGD" />
                                                                <label for="rbx-p-USD/SGD"
                                                                    class="rbx-option">USD/SGD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/SGD" name="pair"
                                                                    class="hidden-cbx" value="USD/SGD" />
                                                                <label for="rbx-p-USD/SGD"
                                                                    class="rbx-option">USD/SGD</label>
                                                            </li>
                                                            <li class="cs-item">
                                                                <input type="radio" id="rbx-p-USD/ZAR" name="pair"
                                                                    class="hidden-cbx" value="USD/ZAR" />
                                                                <label for="rbx-p-USD/ZAR"
                                                                    class="rbx-option">USD/ZAR</label>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <label for="ls" class="field-input --required"><span
                                                        class="field-label"><strong>头寸数量</strong> (单位)
                                                    </span>
                                                    <input id="ls" name="ls" required="required" placeholder="—"
                                                        type="text" class="field" /></label>
                                                <div class="calc-ask-price js-calc-ask-price" style="display: none">
                                                    <label for="price" class="field-input"><span id="pricet"
                                                            class="field-label"><strong>当前价格 EUR/USD 卖价</strong></span>
                                                        <input id="price" name="price" placeholder="—" type="text"
                                                            class="field" /></label>
                                                </div>
                                                <button type="submit" value="btn" class="btn">
                                                    计算
                                                </button>
                                            </form>
                                            <div class="calculator__result --pip-calculator --open">
                                                <div class="calculator__result-row --header">
                                                    <div title="结果" class="calculator__result-cell">
                                                        结果
                                                    </div>
                                                    <div class="calculator__result-cell"></div>
                                                </div>
                                                <div class="calculator__result-row">
                                                    <div title="结果" class="calculator__result-cell">
                                                        点的价值
                                                    </div>
                                                    <div id="pip"
                                                        class="calculator__result-cell calculator__result-cell"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <section class="section2">
                                        <div class="pivot-point-calc-card__text">
                                            虽然了解如EUR/USD,
                                            GBP/USD这样的货币对以美元表示的一个点价值非常简单，但是如果您的账户以其它货币表示，或者货币对的基础货币与您账户货币不同，那么要计算这些货币对的点值就非常困难。这些货币对也需要输入卖/买价格以便将点值转换为账户货币的形式。
                                        </div>
                                    </section>
                                </div>
                            </main>
                        </div>

                        <!---->
                        <div class="calc-modal">
                            <div class="calc-modal__hider"></div>
                            <div class="calc-modal__content">
                                <h4 id="calc-modal__text" class="calc-modal__text accent">
                                    请输入当前价格。
                                </h4>
                                <button type="button" class="btn" id="calc-modal-ok">OK</button>
                            </div>
                        </div>
                        <!---->
                        <!---->
                    </div>
                </div>

                <section class="forex-section">
                    <footerDetail></footerDetail>
                </section>
            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>
<script>
import calcs from "../../assets/js/calcs.js";
import forexMenu from '../../components/forex-menu/forex-menu.vue';
import footerDetail from "../../components/footer-detail/footer-detail.vue";

export default {
    components: {
        forexMenu,
        footerDetail
    },
    mounted() {
        calcs();
        $("#calc-modal-ok").click(function () {
            $(".calc-modal").removeClass("--open");
            $("body").css("overflow", "visible");
        });
    }
}
</script>

<style>
    body{
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
    }
</style>
<style scoped>
@import url("../../assets/css/forex/rem.css");
@import url("../../assets/css/forex/common.css");

.forex-index {
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
}

body {
    font-size: 16rem;
}

.section1 {
    margin-top: 50rem;
}

section+section {
    margin-top: 88rem;
}

.nuxt-progress {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    width: 0;
    opacity: 1;
    -webkit-transition: width 0.1s, opacity 0.4s;
    -o-transition: width 0.1s, opacity 0.4s;
    -moz-transition: width 0.1s, opacity 0.4s;
    transition: width 0.1s, opacity 0.4s;
    background-color: #4fd1c5;
    z-index: 999999;
}

.nuxt-progress.nuxt-progress-notransition {
    -webkit-transition: none;
    -o-transition: none;
    -moz-transition: none;
    transition: none;
}

.nuxt-progress-failed {
    background-color: red;
}

.field {
    border-radius: 8rem !important;
}

* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    outline: none !important;
}

body p {
    margin-bottom: 21px;
    margin-top: 0;
}

body.fixed-header {
    padding-top: 62px;
}

body.fixed-header {
    padding-top: 142px;
}

body.fixed-header .header {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 100;
    top: 0;
    -webkit-transform: translateY(-100%);
    -moz-transform: translateY(-100%);
    -ms-transform: translateY(-100%);
    -o-transform: translateY(-100%);
    transform: translateY(-100%);
}

body.fixed-header .header .header__top {
    display: none;
}

body.fixed-header.top .header {
    -webkit-transition: -webkit-transform 0.3s ease-in-out;
    transition: -webkit-transform 0.3s ease-in-out;
    -o-transition: -o-transform 0.3s ease-in-out;
    -moz-transition: transform 0.3s ease-in-out, -moz-transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out;
    transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out,
        -moz-transform 0.3s ease-in-out, -o-transform 0.3s ease-in-out;
    -webkit-transform: translateY(0);
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
}

svg path {
    -webkit-transition: fill 0.3s ease-in-out;
    -o-transition: fill 0.3s ease-in-out;
    -moz-transition: fill 0.3s ease-in-out;
    transition: fill 0.3s ease-in-out;
}

.wrapper {
    margin: auto;
    padding-right: 0;
    padding-left: 0;
}

.code,
kbd,
samp {
    font-family: inherit;
    font-size: inherit;
}

.accent {
    color: #c49a6c;
}

.error-msg {
    color: #f66363;
}

fieldset {
    border: none;
    padding: 0;
}

.content-banner {
    width: 100%;
    margin: 40px 0;
    text-align: center;
}

.content-banner img {
    margin: 0;
    width: auto;
    height: auto;
}

.content-banner iframe,
.content-banner img,
.content-banner ins {
    max-width: 100%;
}

.fade-modal-enter-active,
.fade-modal-leave-active {
    -webkit-transition: opacity 0.5s;
    -o-transition: opacity 0.5s;
    -moz-transition: opacity 0.5s;
    transition: opacity 0.5s;
}

.fade-modal-enter,
.fade-modal-leave-to {
    opacity: 0;
}

.highlight {
    background: #8391a4;
    color: #2d3748;
}

.ar .info-card__btns .btn:not(.--grey),
.rtl .info-card__btns .btn:not(.--grey) {
    margin-right: 0;
    margin-left: 14px;
}

.ar .field-input.--required:after,
.rtl .field-input.--required:after {
    left: 12px;
    right: auto;
}

@-moz-keyframes fly {
    0% {
        left: -20px;
    }

    to {
        left: 100%;
    }
}

@-webkit-keyframes fly {
    0% {
        left: -20px;
    }

    to {
        left: 100%;
    }
}

@-o-keyframes fly {
    0% {
        left: -20px;
    }

    to {
        left: 100%;
    }
}

@keyframes fly {
    0% {
        left: -20px;
    }

    to {
        left: 100%;
    }
}

@-moz-keyframes rotation {
    0% {
        -moz-transform: rotate(0);
        transform: rotate(0);
    }

    to {
        -moz-transform: rotate(2turn);
        transform: rotate(2turn);
    }
}

@-webkit-keyframes rotation {
    0% {
        -webkit-transform: rotate(0);
        transform: rotate(0);
    }

    to {
        -webkit-transform: rotate(2turn);
        transform: rotate(2turn);
    }
}

@-o-keyframes rotation {
    0% {
        -o-transform: rotate(0);
        transform: rotate(0);
    }

    to {
        -o-transform: rotate(2turn);
        transform: rotate(2turn);
    }
}

@keyframes rotation {
    0% {
        -webkit-transform: rotate(0);
        -moz-transform: rotate(0);
        -o-transform: rotate(0);
        transform: rotate(0);
    }

    to {
        -webkit-transform: rotate(2turn);
        -moz-transform: rotate(2turn);
        -o-transform: rotate(2turn);
        transform: rotate(2turn);
    }
}

@-moz-keyframes moving-1 {
    0% {
        top: 50%;
    }

    25% {
        top: 60%;
    }

    50% {
        top: 50%;
    }

    75% {
        top: 10%;
    }

    to {
        top: 50%;
    }
}

@-webkit-keyframes moving-1 {
    0% {
        top: 50%;
    }

    25% {
        top: 60%;
    }

    50% {
        top: 50%;
    }

    75% {
        top: 10%;
    }

    to {
        top: 50%;
    }
}

@-o-keyframes moving-1 {
    0% {
        top: 50%;
    }

    25% {
        top: 60%;
    }

    50% {
        top: 50%;
    }

    75% {
        top: 10%;
    }

    to {
        top: 50%;
    }
}

@keyframes moving-1 {
    0% {
        top: 50%;
    }

    25% {
        top: 60%;
    }

    50% {
        top: 50%;
    }

    75% {
        top: 10%;
    }

    to {
        top: 50%;
    }
}

@-moz-keyframes moving-2 {
    0% {
        top: 10%;
    }

    to {
        top: 60%;
    }
}

@-webkit-keyframes moving-2 {
    0% {
        top: 10%;
    }

    to {
        top: 60%;
    }
}

@-o-keyframes moving-2 {
    0% {
        top: 10%;
    }

    to {
        top: 60%;
    }
}

@keyframes moving-2 {
    0% {
        top: 10%;
    }

    to {
        top: 60%;
    }
}

.page-header {
    margin-bottom: 41px;
}

.page-header__content {
    max-width: 730px;
}

.page-header__label {
    font-weight: 500;
    text-transform: uppercase;
    line-height: 16px;
    color: #8391a4;
    font-size: 10px;
    margin: 39px 0 -28px;
}

.page-header__text {
    margin-bottom: 19px;
}

.page-header a {
    text-decoration: underline;
    text-underline-offset: 2px;
}

.brokers__results {
    margin-bottom: 71px;
}

.brokers__results {
    margin: 0 -16px 101px;
}

.btn {
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.6;
    border: 1px solid #c49a6c;
    padding: 9px 23px 8px;
    display: inline-block;
    color: #2d3748;
    background-color: rgba(0, 0, 0, 0);
}

.btn {
    cursor: pointer;
    -webkit-transition: color 0.3s, background-color 0.3s,
        border-color 0.3s ease-in-out;
    -o-transition: color 0.3s, background-color 0.3s,
        border-color 0.3s ease-in-out;
    -moz-transition: color 0.3s, background-color 0.3s,
        border-color 0.3s ease-in-out;
    transition: color 0.3s, background-color 0.3s, border-color 0.3s ease-in-out;
}

.btn:hover {
    background-color: #4fd1c5;
    color: #fff !important;
}

.btn:hover svg path {
    fill: #fff;
}

.btn.--small {
    padding: 2px 24px;
}

.btn.--grey {
    border-color: #8391a4;
    color: #8391a4;
}

.btn.--grey:hover {
    border-color: #4fd1c5;
    color: #fff;
}

.btn.--grey:hover svg path {
    fill: #fff;
}

.btn.--grey svg path {
    fill: #8391a4;
}

.btn.--green {
    border-color: #4fd1c5;
    color: #fff;
    background-color: #4fd1c5;
}

.btn.--green:hover {
    color: #4fd1c5 !important;
    background-color: #fff;
}

.btn.--inverted {
    border-color: #fff;
    color: #fff;
}

.btn.--inverted:hover {
    background-color: #088a7e;
    border-color: #088a7e;
}

.btn.--dark-green {
    border-color: #088a7e;
    color: #088a7e;
}

.btn.--dark-green:hover {
    border-color: #fff;
    color: #fff;
}

.btn.--white {
    border-color: #fff;
    color: #fff;
}

.btn.--white:hover {
    border-color: #2d3748;
    color: #2d3748 !important;
}

.btn.--disabled {
    border-color: #8391a4;
    color: #8391a4;
    pointer-events: none;
    opacity: 0.6;
}

.load-btn {
    -webkit-appearance: none;
    background-color: rgba(0, 0, 0, 0);
    outline: 0;
    border: none;
    text-transform: uppercase;
    padding: 7px 5px 7px 47px;
    position: relative;
    font-weight: 500;
    line-height: 22px;
    color: #8391a4;
}

.load-btn {
    -webkit-transition: color 0.3s ease-in-out;
    -o-transition: color 0.3s ease-in-out;
    -moz-transition: color 0.3s ease-in-out;
    transition: color 0.3s ease-in-out;
}

.load-btn:hover {
    cursor: pointer;
    color: #4fd1c5;
}

.load-btn:hover svg path {
    fill: #4fd1c5;
}

.load-btn svg {
    position: absolute;
    left: 17px;
    top: 9px;
}

/* .calculator__title {
    color: #fff;
} */

.calculator__wrap {}

.calculator__wrap form {
    border-radius: 8rem;
    overflow: hidden;
}

.calculator__wrap .calculator__desc {
    color: #222222;
    margin-bottom: 40px;
}

.calculator__subtitle {
    margin: 0 0 40px;
}

.calculator__subtitle {
    margin-bottom: 20px;
    max-width: 1080px;
}

.calculator__desc {
    font-size: 14px;
    line-height: 1.5;
    max-width: 700px;
    margin-bottom: 70px;
}

.calculator__desc {
    margin-bottom: 100px;
}

.calculator__form .btn {
    /* width: -webkit-min-content;
  width: -moz-min-content;
  width: min-content; */
    min-height: 42rem;
    grid-column: 1/-1;
    white-space: nowrap;
    background: #a52933;
    color: #fff;
    font-size: 16rem;
    border: none;
}

.calculator__form .input__label {
    display: block;
    font: 400 10px/1.3 TTTravels, sans-serif;
    margin-bottom: 10px;
}

.calculator__form .input__label strong {
    font-size: 15px;
}

.calculator__form {
    display: grid;
    background: #f9fafc;
    margin-top: 48rem;
    grid-template-columns: 1fr 1fr;
    grid-gap: 18rem 40rem;
    padding: 32rem 24rem 40rem;
}

.calculator__result {
    display: none;
}

.calculator__result {
    padding: 32rem 24rem;
    background: #fbfcfd;
}

.calculator__result-row {
    background: #fbfcfd;
    padding: 30px;
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px 15px;
    border-top: 1px solid #e4e7ea;
}

.calculator__result-row {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    margin-top: 0;
    padding: 19px 0 18px;
}

.calculator__result-row.--header {
    display: none;
}

.calculator__result-row.--header {
    display: grid;
    padding: 38px 0;
    border-top: 1px dashed #c4d4e9;
}

.calculator__result-row.--header .calculator__result-cell {
    text-transform: uppercase;
    color: #8391a4;
    font-weight: 500;
    font-size: 12rem;
    line-height: 1.6;
}

.calculator__result-cell {
    font-size: 14rem;
}

.calculator__result-cell:before {
    content: attr(title);
    display: block;
    font-size: 10px;
    min-height: 16px;
    font-weight: 500;
    color: #8391a4;
    margin-bottom: 4px;
}

.calculator__result-cell:before {
    display: none;
}

.calculator__result-cell:first-child {
    font-weight: normal;
    font-size: 15rem;
    letter-spacing: -0.02em;
    font-family: TTTravels;
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ea;
    grid-column: 1/3;
}

.calculator__result-cell:first-child:before {
    margin-bottom: 0;
}

.calculator__result-cell:first-child {
    grid-column: unset;
    padding-bottom: 0;
    border-bottom: none;
}

.calculator__result.--open {
    display: block;
}

.calculator__result.--pip-calculator .calculator__result-row,
.calculator__result.--position-size-calculator .calculator__result-row {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    grid-template-columns: repeat(2, 200px);
}

.calculator__result.--pivot-points-calculator .calculator__result-row,
.calculator__result.--risk-reward-calculator .calculator__result-row {
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    grid-template-columns: repeat(5, 1fr);
}

.calculator__buttons {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    grid-gap: 20px;
    grid-column: 1/-1;
}

body .tippy-tooltip.light-border-theme {
    font-size: 11px;
    -webkit-border-radius: 25px;
    -moz-border-radius: 25px;
    border-radius: 25px;
    color: #000;
    color: initial;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    line-height: 1.3;
    border: 1px solid #e4e7ea;
}

body .tippy-tooltip.light-border-theme a {
    color: #4fd1c5;
}

body .tippy-tooltip.light-border-theme a:hover {
    color: #088a7e;
}

input[placeholder] {
    color: #8391a4;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    opacity: 1;
    -webkit-transition: opacity 0.3s ease;
    -o-transition: opacity 0.3s ease;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input::-ms-input-placeholder {
    color: #8391a4;
    text-overflow: ellipsis;
    opacity: 1;
    -ms-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input::placeholder {
    color: #8391a4;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    opacity: 1;
    -webkit-transition: opacity 0.3s ease;
    -o-transition: opacity 0.3s ease;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input::-webkit-input-placeholder {
    color: #8391a4;
    text-overflow: ellipsis;
    opacity: 1;
    -webkit-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:-moz-placeholder,
input::-moz-placeholder {
    color: #8391a4;
    text-overflow: ellipsis;
    opacity: 1;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:-ms-input-placeholder {
    color: #8391a4;
    text-overflow: ellipsis;
    opacity: 1;
    -ms-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:focus::-webkit-input-placeholder {
    opacity: 0;
    -webkit-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:focus::-moz-placeholder {
    opacity: 0;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:focus:-moz-placeholder {
    opacity: 0;
    -moz-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input:focus:-ms-input-placeholder {
    opacity: 0;
    -ms-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
}

input[type="date"],
input[type="email"],
input[type="number"],
input[type="password"],
input[type="tel"],
input[type="text"],
textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 1px solid #e4e7ea;
    padding: 13px 15px 11px;
    width: 100%;
    color: #2d3748;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
}

textarea {
    height: 138px;
    resize: none;
}

.custom-dropdown {
    position: relative;
    z-index: 2;
    width: 100%;
    margin-bottom: 20px;
}

.custom-dropdown.cs-open {
    z-index: 3;
}

.custom-dropdown.cs-open .cs-placeholder {
    display: block;
}

.custom-dropdown.cs-open .cs-placeholder:after {
    -webkit-transform: rotateX(160deg);
    -moz-transform: rotateX(160deg);
    transform: rotateX(160deg);
}

.custom-dropdown.cs-open .cs-options {
    display: block;
}

.custom-dropdown .cs-placeholder {
    color: #2d3748;
    position: relative;
    z-index: 2;
    border: 1px solid #e4e7ea;
    cursor: pointer;
    padding: 11px 24px 7px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    width: 100%;
}

.custom-dropdown .cs-placeholder {
    cursor: pointer;
}

.custom-dropdown .cs-placeholder:after {
    content: "";
    width: 0;
    height: 0;
    border-top: 5px solid #2d3748;
    border-left: 4px solid rgba(0, 0, 0, 0);
    border-right: 4px solid rgba(0, 0, 0, 0);
    position: absolute;
    left: 8px;
    top: 19px;
    -webkit-transition: border-color 0.3s ease-in-out, -webkit-transform 0.3s;
    transition: border-color 0.3s ease-in-out, -webkit-transform 0.3s;
    -o-transition: border-color 0.3s ease-in-out, -o-transform 0.3s;
    -moz-transition: transform 0.3s, border-color 0.3s ease-in-out,
        -moz-transform 0.3s;
    transition: transform 0.3s, border-color 0.3s ease-in-out;
    transition: transform 0.3s, border-color 0.3s ease-in-out,
        -webkit-transform 0.3s, -moz-transform 0.3s, -o-transform 0.3s;
}

.custom-dropdown .cs-options {
    margin: 0;
    color: #2d3748;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    background-color: #fff;
    display: none;
    -webkit-box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    -moz-box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    list-style: none;
    z-index: 1;
    overflow-y: auto;
    max-height: 350px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    padding: 7px 0;
}

.custom-dropdown .cs-options {
    scrollbar-color: #4fd1c5 rgba(0, 0, 0, 0);
    scrollbar-width: thin;
}

.custom-dropdown .cs-options::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0);
}

.custom-dropdown .cs-options::-webkit-scrollbar {
    width: 4px;
    -webkit-border-radius: 0;
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0);
}

.custom-dropdown .cs-options::-webkit-scrollbar-thumb {
    background-color: #4fd1c5;
    width: 4px;
    -webkit-border-radius: 0;
    border-radius: 0;
}

.custom-dropdown .cs-item {
    margin: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: block;
}

.custom-dropdown .cs-item {
    -webkit-transition: color 0.3s ease-in-out;
    -o-transition: color 0.3s ease-in-out;
    -moz-transition: color 0.3s ease-in-out;
    transition: color 0.3s ease-in-out;
}

.custom-dropdown .cs-item:hover {
    color: #4fd1c5;
}

.custom-dropdown .cs-item .hidden-cbx {
    display: none;
}

.custom-dropdown .cs-item .hidden-cbx:checked+.rbx-option {
    color: #4fd1c5;
    pointer-events: none;
}

.custom-dropdown .rbx-option {
    display: block;
    padding: 5px 24px;
    cursor: pointer;
}

.field-input {
    margin-bottom: 20px;
    display: block;
    -webkit-align-self: flex-start;
    -ms-flex-item-align: start;
    align-self: flex-start;
}

.field-input.--required {
    position: relative;
}

.field-input.--required:after {
    content: "*";
    line-height: 0;
    position: absolute;
    right: 12px;
    bottom: 17px;
}

.field-input .field-label {
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    color: #8391a4;
    margin-bottom: 5px;
    display: block;
}

.field-input .field-label strong {
    font-family: TTTravels;
    font-weight: normal;
    font-size: 14rem;
    /* line-height: 19px; */
    /* letter-spacing: -0.02em; */
    color: #232222;
}

.form-calculator .calc-label-risk {
    display: block;
}

.form-calculator .calc-label-money,
.form-calculator .change-units .calc-label-risk {
    display: none;
}

.form-calculator .change-units .calc-label-money {
    display: block;
}

.table-calculator .calc-label-risk {
    display: none;
}

.table-calculator .calc-label-money,
.table-calculator .change-units .calc-label-risk {
    display: block;
}

.table-calculator .change-units .calc-label-money {
    display: none;
}

.btn.field {
    margin: 28px 0 20px;
}

.app-select {
    position: relative;
    z-index: 2;
    width: 100%;
    margin-bottom: 20px;
}

.app-select.--light .app-select__selected {
    background-color: rgba(0, 0, 0, 0);
    border-color: #e4e7ea;
    color: #2d3748;
}

.app-select.--light .app-select__selected:after {
    border-top-color: #2d3748;
}

.app-select.--open {
    z-index: 3;
}

.app-select.--open .app-select__selected:after {
    -webkit-transform: rotateX(160deg);
    -moz-transform: rotateX(160deg);
    transform: rotateX(160deg);
}

.app-select.--open .app-select__dropdown {
    display: block;
}

.app-select.--disabled {
    pointer-events: none;
    opacity: 0.6;
}

.app-select.--error .app-select__selected {
    border-color: #f66363;
}

.app-select__label {
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-transform: uppercase;
    color: #8391a4;
    margin-bottom: 5px;
    display: block;
}

.app-select__selected {
    position: relative;
    background-color: #2d3748;
    border: 1px solid rgba(228, 231, 234, 0.2);
    cursor: pointer;
    padding: 11px 24px 7px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
}

.app-select__selected {
    cursor: pointer;
}

.app-select__selected:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 4px solid rgba(0, 0, 0, 0);
    border-right: 4px solid rgba(0, 0, 0, 0);
    border-top: 5px solid #fff;
    position: absolute;
    left: 8px;
    top: 19px;
    -webkit-transition: border-color 0.3s ease-in-out, -webkit-transform 0.3s;
    transition: border-color 0.3s ease-in-out, -webkit-transform 0.3s;
    -o-transition: border-color 0.3s ease-in-out, -o-transform 0.3s;
    -moz-transition: transform 0.3s, border-color 0.3s ease-in-out,
        -moz-transform 0.3s;
    transition: transform 0.3s, border-color 0.3s ease-in-out;
    transition: transform 0.3s, border-color 0.3s ease-in-out,
        -webkit-transform 0.3s, -moz-transform 0.3s, -o-transform 0.3s;
}

.app-select__selected span {
    display: inline-block;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
}

.app-select__dropdown {
    color: #2d3748;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    background-color: #fff;
    display: none;
    -webkit-box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    -moz-box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    box-shadow: 0 10px 20px rgba(167, 176, 195, 0.2);
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    min-width: 100%;
}

.app-select__items {
    overflow-y: auto;
    max-height: 350px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    padding: 7px 0;
}

.app-select__items {
    scrollbar-color: #4fd1c5 rgba(0, 0, 0, 0);
    scrollbar-width: thin;
}

.app-select__items::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0);
}

.app-select__items::-webkit-scrollbar {
    width: 4px;
    -webkit-border-radius: 0;
    border-radius: 0;
    background-color: rgba(0, 0, 0, 0);
}

.app-select__items::-webkit-scrollbar-thumb {
    background-color: #4fd1c5;
    width: 4px;
    -webkit-border-radius: 0;
    border-radius: 0;
}

.app-select__item {
    padding: 5px 24px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.app-select__item {
    -webkit-transition: color 0.3s ease-in-out;
    -o-transition: color 0.3s ease-in-out;
    -moz-transition: color 0.3s ease-in-out;
    transition: color 0.3s ease-in-out;
}

.app-select__item:hover {
    color: #4fd1c5;
}

.app-select__item.--active {
    color: #4fd1c5;
    pointer-events: none;
}

.app-select__item.--placeholder {
    color: #a0aec0;
}

.app-select__wrap.--error .app-select__selected {
    border-color: #f66363;
}

#calc-modal-ok {
    background: #c49a6c;
    color: #fff;
    font-size: 16px;
}

#calc-modal-ok:hover {
    background: #c49a6c;
}

@media (max-width: 996px) {
    .calculator__cards {
        margin-bottom: 28px;
    }
}

.home-header-bd .navbar-brand {
    padding-top: 6px;
}

.anotherCalculatorCTA {
    padding: 40px 16px 50px;
    margin: 0 -16px;
    background: #4fd1c5;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 70px;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 100px;
}

.anotherCalculatorCTA {
    padding: 40px 50px 50px;
    max-width: 1440px;
    margin: 0 auto;
}

.anotherCalculatorCTA__title {
    font-size: 40px;
    color: #fff;
    margin: 0 0 20px;
    max-width: 700px;
}

.anotherCalculatorCTA__link {
    color: #088a7e;
}

.anotherCalculatorCTA__text {
    font-size: 14px;
    font-family: Inter, sans-serif;
    line-height: 1.4;
    color: #fff;
    max-width: 700px;
}

.anotherCalculatorCTA__text {
    margin-bottom: 20px;
    line-height: 1.6;
}

.calculator__cards {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
    margin-bottom: 70px;
}

.calculator__cards {
    grid-gap: 40px;
    gap: 40px;
    margin-bottom: 80px;
}

.calculator__cards-item {
    padding: 20px 0;
}

.pivot-point-calc-card {
    background: #fff;
}

.pivot-point-calc-card__title {
    font-size: 20rem;
    margin: 0 0 20px;
}

.pivot-point-calc-card__title {
    margin-bottom: 18px;
}

.pivot-point-calc-card__text {
    font-size: 14rem;
    line-height: 1.5;
}

.pivot-point-calc-card__text p {
    margin: 0 0 22px;
}

.pivot-point-calc-card__text {
    line-height: 1.55;
}

.pivot-point-calc-card__formulas {
    padding: 15rem;
    border: 1px solid #c49a6c;
    font-size: 14rem;
}

.pivot-point-calc-card__formulas p {
    margin: 0;
}

.pivot-point-calc-card__formulas {
    padding: 17px 20px;
    line-height: 1.6;
}

.calc-modal {
    position: fixed;
    z-index: 9999;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    display: none;
}

.calc-modal.--open {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
}

.calc-modal__hider {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.75);
    z-index: 1;
    cursor: pointer;
}

.calc-modal__content {
    position: relative;
    width: 300px;
    padding: 20px 25px;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -moz-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-top: 5px solid #c49a6c;
    z-index: 5;
}

.calc-modal__content {
    width: 600px;
    padding: 50px 25px;
}

.calc-modal__text {
    margin: 0 0 30px;
}

.anotherCalculatorCTA {
    padding: 40px 16px 50px;
    margin: 0 -16px;
    background: #4fd1c5;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 70px;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 100px;
}

.anotherCalculatorCTA {
    padding: 40px 50px 50px;
    max-width: 1440px;
    margin: 0 auto;
}

.anotherCalculatorCTA__title {
    font-size: 40px;
    color: #fff;
    margin: 0 0 20px;
    max-width: 700px;
}

.anotherCalculatorCTA__link {
    color: #088a7e;
}

.anotherCalculatorCTA__text {
    font-size: 14px;
    font-family: Inter, sans-serif;
    line-height: 1.4;
    color: #fff;
    max-width: 700px;
}

.anotherCalculatorCTA__text {
    margin-bottom: 20px;
    line-height: 1.6;
}

.simple-banner {
    font-size: 22px;
    line-height: 29px;
    display: block;
    padding: 40px 16px;
    background-color: #c49a6c;
    font-family: TTTravels;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #fff;
    margin: 0 -16px 70px;
}

.simple-banner {
    font-size: 30px;
    padding: 70px 120px;
    max-width: 1440px;
    margin: 0 auto 100px;
}

.simple-banner a {
    color: #088a7e;
}

.simple-banner a:hover {
    color: #005951 !important;
}

.simple-banner .accent {
    color: #8c5c27;
}

.simple-banner {
    font-size: 22px;
    line-height: 29px;
    display: block;
    padding: 40px 16px;
    background-color: #4fd1c5;
    font-family: TTTravels;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #fff;
    margin: 0 -16px 70px;
}

.simple-banner {
    font-size: 30px;
    padding: 70px 120px;
    max-width: 1440px;
    margin: 0 auto 100px;
}

.simple-banner a {
    color: #088a7e;
}

.simple-banner a:hover {
    color: #005951 !important;
}

.simple-banner .accent {
    color: #088a7e;
}

.info-banner {
    color: #4fd1c5;
    padding: 27px 28px 7px;
    margin: 20px 0;
    border: 2px solid #4fd1c5;
}

.info-banner.--warning {
    background-color: #fbc334;
    border-color: #fbc334;
    color: #fff;
}

.info-banner.--warning .info-banner__icon {
    background-image: url(../../assets/image/forex/tools/warning-icon.svg);
}

.info-banner.--warning a:not([class]) {
    text-decoration: underline;
    color: #fff;
    -webkit-text-decoration-color: #ffe49e;
    -moz-text-decoration-color: #ffe49e;
    text-decoration-color: #ffe49e;
}

.info-banner.--warning a:not([class]):visited {
    color: #ffe193;
}

.info-banner.--warning a:not([class]):hover {
    color: #ffe193;
}

.info-banner.--info {
    background-color: #4fd1c5;
    border-color: #4fd1c5;
    color: #fff;
}

.info-banner.--info .info-banner__icon {
    /* background-image: url(../../assets/image/forex/tools/like-icon.svg); */
}

.info-banner.--info a:not([class]) {
    color: #fff;
    text-decoration: underline;
    -webkit-text-decoration-color: #eee;
    -moz-text-decoration-color: #eee;
    text-decoration-color: #eee;
}

.info-banner.--info a:not([class]):visited {
    color: #eee;
}

.info-banner.--info a:not([class]):hover {
    color: #eee;
}

.info-banner__icon {
    width: 60px;
    height: 60px;
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    background-repeat: no-repeat;
    background-position: 50%;
    -moz-background-size: contain;
    background-size: contain;
    background-image: url(/svg/idea-icon.svg);
    margin-bottom: 30px;
}

.info-banner__content {
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    -moz-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
}

.info-banner h3,
.info-banner h4 {
    margin: 0;
    max-width: 100%;
}

.info-banner h4 {
    font-size: 22px;
    line-height: 29px;
}

.info-banner p {
    margin-top: 0;
    max-width: 100%;
}

.info-banner a:not([class]) {
    color: #4fd1c5;
    -webkit-text-decoration-color: #8ce9e1;
    -moz-text-decoration-color: #8ce9e1;
    text-decoration-color: #8ce9e1;
}

.info-banner a:not([class]):visited {
    color: #8ce9e1;
}

.info-banner a:not([class]):hover {
    color: #4fd1c5;
}

.info-banner__text {
    margin-top: 20px;
    max-width: 690px;
}

.anotherCalculatorCTA {
    padding: 40px 16px 50px;
    margin: 0 -16px;
    background: #4fd1c5;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 70px;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 100px;
}

.anotherCalculatorCTA {
    padding: 40px 50px 50px;
    max-width: 1440px;
    margin: 0 auto;
}

.anotherCalculatorCTA__title {
    font-size: 40px;
    color: #fff;
    margin: 0 0 20px;
    max-width: 700px;
}

.anotherCalculatorCTA__link {
    color: #088a7e;
}

.anotherCalculatorCTA__text {
    font-size: 14px;
    font-family: Inter, sans-serif;
    line-height: 1.4;
    color: #fff;
    max-width: 700px;
}

.anotherCalculatorCTA__text {
    margin-bottom: 20px;
    line-height: 1.6;
}

.risk-reward__info {
    margin-bottom: 70px;
}

.risk-reward__info {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.risk-reward__about {
    margin-bottom: 40px;
}

.risk-reward__about {
    width: 100%;
    max-width: 600px;
    margin-right: 80px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 40px;
}

.risk-reward__title {
    margin-top: 0;
}

.risk-reward__title {
    margin: 0;
    grid-column: 1/-1;
}

.risk-reward__desc {
    margin-bottom: 40px;
    line-height: 1.3;
}

.risk-reward__desc {
    grid-column: 1/-1;
    margin: -20px 0 0;
}

.risk-reward__text {
    color: #a0aec0;
    line-height: 1.3;
}

.risk-reward__text {
    margin-bottom: 0;
}

.risk-reward__images {
    margin: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
}

.risk-reward__images {
    width: 100%;
    max-width: 760px;
    grid-gap: 40px;
}

.anotherCalculatorCTA {
    padding: 40px 16px 50px;
    margin: 0 -16px;
    background: #4fd1c5;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 70px;
}

.anotherCalculatorCTA+.anotherCalculatorCTA {
    margin-top: 100px;
}

.anotherCalculatorCTA {
    padding: 40px 50px 50px;
    max-width: 1440px;
    margin: 0 auto;
}

.anotherCalculatorCTA__title {
    font-size: 40px;
    color: #fff;
    margin: 0 0 20px;
    max-width: 700px;
}

.anotherCalculatorCTA__link {
    color: #088a7e;
}

.anotherCalculatorCTA__text {
    font-size: 14px;
    font-family: Inter, sans-serif;
    line-height: 1.4;
    color: #fff;
    max-width: 700px;
}

.anotherCalculatorCTA__text {
    margin-bottom: 20px;
    line-height: 1.6;
}

.simple-banner {
    font-size: 22px;
    line-height: 29px;
    display: block;
    padding: 40px 16px;
    background-color: #c49a6c;
    font-family: TTTravels;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #fff;
    margin: 0 -16px 70px;
}

.simple-banner {
    font-size: 30px;
    padding: 70px 120px;
    max-width: 1440px;
    margin: 0 auto 100px;
}

.simple-banner a {
    color: #088a7e;
}

.simple-banner a:hover {
    color: #005951 !important;
}

.simple-banner .accent {
    color: #088a7e;
}

.sect-list {
    padding: 1px 0;
    margin-bottom: 35px;
}

.sect-list {
    margin-bottom: 50px;
}

.sect-list.--five-cols .sect-list__list-item {
    width: 20%;
}

.sect-list.--five-cols .sect-list__list-item:nth-of-type(4n) {
    padding-right: 35px;
}

.sect-list.--five-cols .sect-list__list-item:nth-of-type(5n) {
    padding-right: 0;
}

.sect-list h2,
.sect-list h3 {
    max-width: 1045px;
}

.sect-list h4 {
    max-width: 810px;
}

.sect-list__list {
    padding: 0;
    list-style-type: none;
    margin: 28px 0 20px;
    font-size: 14px;
}

.sect-list__list-item {
    padding-top: 24px;
    position: relative;
    margin-bottom: 9px;
}

.sect-list__list-item {
    width: 25%;
    margin-bottom: 30px;
    padding-right: 35px;
}

.sect-list__list-item:nth-of-type(3n) {
    padding-right: 35px;
}

.sect-list__list-item:nth-of-type(4n) {
    padding-right: 0;
}

.sect-list__list-item:before {
    content: "";
    background-color: #4fd1c5;
    height: 4px;
    width: 35px;
    display: block;
    position: absolute;
    top: 10px;
    left: 0;
}

.sect-list__list-item a {
    color: #4fd1c5;
}

.sect-list__list-item a:hover {
    color: #088a7e;
}

.sect-list__text {
    max-width: 720px;
}

.sect-list__footer-text {
    font-family: TTTravels;
    font-weight: 700;
    font-size: 15px;
    line-height: 19px;
    letter-spacing: -0.02em;
    margin-top: 40px;
}

.sect-list__footer-tip {
    color: #8391a4;
    max-width: 1030px;
    margin-top: 41px;
}

.ar .sect-list__list-item,
.rtl .sect-list__list-item {
    padding-right: 0;
    padding-left: 35px;
}

.ar .sect-list__list-item:before,
.rtl .sect-list__list-item:before {
    left: unset;
    right: 0;
}

.form-calculator__res {
    grid-column: 1/1;
    grid-row: 6/6;
}

.form-calculator__res {
    grid-column: 1/3;
    grid-row: 4/4;
}

.form-calculator__res p {
    border-top: 1px dashed #8391a4;
    padding-top: 12px;
}

.form-calculator .state-lost-text {
    color: #f66363;
}

.form-calculator .state-won-text {
    color: #4fd1c5;
}

.form-calculator .status-button {
    display: inline-block;
}

.form-calculator .status-button__text {
    display: none;
    color: #fff;
    padding: 9px 15px;
    min-width: 150px;
    text-align: center;
    cursor: pointer;
}

.form-calculator .status-button__text.status-button__text--won {
    background-color: #3dbd82;
}

.form-calculator .status-button__text.status-button__text--lost {
    background-color: #f66363;
}

.form-calculator .status-button__input {
    display: none;
}

.form-calculator .status-button__input:checked~.status-button__text--won,
.form-calculator .status-button__input:not(:checked)~.status-button__text--lost {
    display: inline-block;
}

@media (max-width: 996px) {
    .calculator__form {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 18rem;
        background: #f9fafc;
        padding: 30rem 30rem 28rem;
        border-radius: 8rem;
    }

    .field-input .field-label strong {
        font-size: 28rem;
    }

    input[type="date"],
    input[type="email"],
    input[type="number"],
    input[type="password"],
    input[type="tel"],
    input[type="text"],
    textarea {
        font-size: 24rem;
    }

    .calculator__form .btn {
        font-size: 32rem;
        height: 80rem;
        border-radius: 16rem;
    }

    .pivot-point-calc-card__title {
        font-size: 40rem;
    }

    .pivot-point-calc-card__text {
        font-size: 28rem;
    }

    .pivot-point-calc-card__formulas {
        font-size: 28rem;
    }

    .calculator__result-row.--header .calculator__result-cell {
        font-size: 24rem;
    }

    .calculator__result-cell {
        font-size: 28rem;
    }

    .calculator__result-cell:first-child {
        font-size: 30rem;
    }

    .calculator__result {
        padding: 0 30rem;
    }

    .video-list-box {
        display: none;
    }

    .article-item {
        display: none;
    }

    .article-item:nth-child(-n + 2) {
        display: flex;
    }

    .field {
        border-radius: 16rem !important;
    }
}
</style>